import React from 'react';
import '../styles/Services.css';

function Services() {
    return (
        <section className="services" id="services">
            <h2>Hizmetlerimiz</h2>
            <ul>
                <li>🚗 Oto Çekici</li>
                <li>🔧 Yol Yardımı</li>
            </ul>
        </section>
    );
}

export default Services;
